const RecordingStates = Object.freeze({
    START_RECORDING: 1,
    PAUSE_RECORDING: 2,
    RESUME_RECORDING: 3
});

export default RecordingStates;